import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { ConfigParking } from "./add-parking-integration.component";
import { environment } from "environments/environment";
import { Credenciado } from "../model/credenciado";
import { AssinaturaCredenciado } from "../model/assinatura-credenciado";
import { AbParking } from "app/abstract/full-pages/estacionamento/parking.abstract";


@Injectable({ providedIn: 'root' })
export class ParkingService extends AbParking {

  constructor(http: HttpClient) {
    super(http);
  }

  salvar(configParking: ConfigParking): Observable<any> {
    return this.save("config_parking/", configParking);
  }

  async obterConfigParkingCadastrado() {
    let retorno = null;
    await this.http.get(`${environment.urlApi}config_parking/1`).toPromise().then(data => {
      retorno = data;
    });
    return retorno;
  }

  async obterCredenciados(url: string, queryParams: any) {
    let credenciados = null;
    await this.http.get<Credenciado[]>(url, { params: queryParams }).toPromise().then(data => {
      credenciados = data;
    })
    return credenciados;
  }

  async obterAssinaturas(urlToLoadSignatures: string, queryParams: any) {
    let assinaturas = null;
    await this.http.get<AssinaturaCredenciado[]>(urlToLoadSignatures, { params: queryParams }).toPromise().then(data => {
      assinaturas = data;
    });
    return assinaturas;
  }


}
